<template>
    <div>
      <!--搜索框-->
      <div class="search-bg">
        <el-input
          class="search-input"
          placeholder="请输入内容"
          v-model="search"
          clearable>
        </el-input>
        <el-select v-model="selectValue" placeholder="请选择搜索方式" style="margin-right:10px;">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            >
          </el-option>
        </el-select>
        <el-button type="success" @click="SearchData(1)">搜索</el-button>
      </div>
      <!--搜索后的-->
      <div :class="{'search-bg-active':isActive}">
        <ul class="newslist-bg" >
          <!--<li  v-for="(item,index) in searchData" :key="index" ><router-link :to='/contentPage/ + item.id'>{{item.title}}</router-link></li>-->
          <li  v-for="(item,index) in searchData" >
            <div class="news-content-bg">
              <div class="news-content">
                <h3 class="news-title" @click="contentPage(item.id)">{{item.title}}</h3>
                <p> {{item.description}}</p>
              </div>
              <div class="news-time">
                <span>{{$t('common.Author')}}：{{item.author}}</span>{{item.createTime}}<i>{{$t('common.Views')}}：{{item.hits}}</i>
              </div>
            </div>
            <div v-if='item.thumbnail !== "" && item.thumbnail !=null'><img class="news-img" :src="item.thumbnail"/></div>
            <div v-else></div>
          </li>
        </ul>
        <!--分页-->
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="number"
          :page-size="size"
          id="pagination"
          layout="total, prev, pager, next, jumper"
          :page-count="totalPages">
        </el-pagination>
      </div>

    </div>
</template>

<script>
  import axios from '@/axios'

  export default {
    name: "tutorial",
    data() {
      return {
        seagate:'seagate',
        wd:'wd',
        hitachi:'hitachi',
        toshiba:'toshiba',
        other:'other',
        search: '',
        searchList:[],
        searchData:[],
        list:[],
        isActive:true,
        options: [{
          value: 'A',
          label: '仅标题搜索'
        }, {
          value: 'B',
          label: '智能模糊搜索'
        }],
        selectValue: '',
        totalPages: 0,//总页数
        totalElements: 0, //总条数
        size: 0, //当前页条数
        number: 1, //当前页从1开始
      }
    },
    created: function () {
    },
    methods: {
      SearchData(currentPage){
        var search = this.search;  //搜索框输入内容
        let _this = this;
        _this.searchList=[]
        _this.$emit('searchData', search)  //向父组件传递搜索框输入内容
        let url='';  // 获取数据url
        if (search && _this.selectValue==='A') {      //标题搜索
          _this.isActive = false;
          url = 'article/likeTitle?title='+ search+ '&page=' + currentPage
        }else if (search && _this.selectValue==='B') {   //智能模糊搜索
              _this.isActive = false;
          url = 'article/likeDescription?description='+ search+ '&page=' + currentPage
            }else {
              _this.isActive = true;
            }
        axios.get(this.$store.state.apiBasePath  + url)
          .then(function (res) {
            if(res.data.code === 200){
              let dataList = res.data.data.list;
              console.log(res.data.data)
              // 遍历数组
              dataList.forEach((element,index,array)=>{
                _this.searchList.push(element.tarticlesList);
              })
              // 合并双重数组的值
              _this.searchData = _this.searchList.flat()

              _this.totalPages = res.data.data.pages;
              _this.number = res.data.data.pageNum; //服务器返回数据从0开始，分页组件从1开始，所以要加1
              _this.size = res.data.data.size;
            }
          })
      },
      tutorialFromChild(data){
        this.list=data;
        // console.log(  this.list);
      },

      //当前页  currentPage 改变时会触发
      handleCurrentChange: function (currentPage) {
        this.number = currentPage;
        this.SearchData(currentPage);
      },


      contentPage(id) {
        // this.$router.push({path: "/contentPage/" + id, query: {url: this.url}})
        //跳转新页面 url: this.url传入对应新闻列表参数
        let routeData = this.$router.resolve({path: "/contentPage/" + id});
        // console.log(routeData);
        //点击跳转新页面
        window.open(routeData.href, '_blank');
      },

    },

  }
</script>

<style scoped>
  .main {
    width: 1170px;
    margin: auto auto 15px auto;
    min-height: calc(100% - 486px);
  }
  .search-bg {display: flex; justify-content: space-between;margin:30px 5px 20px 5px;
    /*position: relative; */
  }
  .search-input {margin-right: 10px;}
  .search-result {
    /*position: absolute;*/
    width: 100%;
    max-height: 300px;
    overflow: scroll;
    background: #000;
    /*top: 50px;*/
    border: #dedede 1px solid;
    box-shadow: #c5c5c5 0 0 8px;
    /*display: none;*/
    transition: all ease 0.3s;
  }
  .search-bg-active {
    display: none;
    transition: all ease 0.3s;}

  .search-result ul {padding: 20px 20px;}
  .search-result ul li {font-size: 14px; line-height: 32px; color:#cfcfcf;}
  .search-result ul li:hover {cursor: pointer; color: #fff;}
  .search-input .el-input__inner:focus {border-color: #00af42;}
  .el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
  .newslist-bg {
    text-align: left;
    margin-bottom: 30px;
  }

  .newslist-bg li {
    text-decoration: none;
    margin: 10px 0;
    display: flex;
    border-bottom: #e6e6e6 1px solid;
    background: #fff;
    padding: 10px 10px 40px 10px;
    justify-content: space-between;
  }

  .news-title {
    margin: 10px 0;
    font-size: 20px;
    color: #000;
    transition: all ease 0.3s;


  }

  .news-title:hover {
    color: #009e3b;
    cursor: pointer;
    transition: all ease 0.3s;
  }

  .news-content-bg {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-right: 15px;
  }

  .news-content {
    font-size: 14px;
    text-align: justify;
    line-height: 24px;
    color: #666;
    margin: 10px 0;
  }

  .news-content p {
    margin: 0 15px 0 0;
    overflow: hidden;
  }

  .news-img {
    height: 200px;
    width: 300px;

  }

  .news-time {
    font-size: 14px;
    color: #666;
  }

  .news-time span {
    color: #009688;
    margin-right: 15px;
  }

  .news-time i {
    font-style: normal;
    margin-left: 15px;
    color: #e60000;
  }


  /*.tutorial-bg { display: flex; flex-wrap: wrap; }*/
  .tutorial-list {display: flex;flex-wrap: wrap; }
  .tutorial-list li {width:49%; font-size: 14px; line-height:36px; transition: all ease 0.3s; display: flex;justify-content: space-between;}
  .tutorial-list li a {text-decoration: none;color: #4c4c4c;position: relative; padding-left: 12px;}
  .tutorial-list li a:hover {color:#009e3b; cursor: pointer; transition: all ease 0.3s;}
  .tutorial-list li a:before {content: ""; position: absolute;width:4px; height: 4px; border-radius: 5px;background:#009e3b;display: block;
    top: 16px;
    left: 0;}


    /*点击排行*/
  .click-ranking {
    width: 340px;
    box-sizing: border-box;
    border: #e5e5e5 1px solid;
  }

  .ranking-title {
    font-size: 20px;
    color: #000;
    text-align: left;
    margin: 10px 10px;
    border-bottom: #e5e5e5 1px solid;
    padding-bottom: 8px;
  }

  .ranking-title span {
    color: #e60000;
  }

  .ranking-img {
    width: 100%;
    height: 160px;
  }

  .ranking-img-bg {
    position: relative;
    height: 160px;
  }

  .ranking-img-bg:hover {
    cursor: pointer;
  }

  .ranking-img-title {
    background: rgba(0, 0, 0, 0.65);
    color: #fff;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    text-align: left;
    height: 36px;
    line-height: 36px;
    overflow: hidden;
  }

  .ranking-img-title span {
    margin: 0 15px;
    display: block;
    font-size: 14px;
  }

  .hot-tag {
    background: url("../../assets/homepage/hot.png") no-repeat;
    width: 31px;
    height: 57px;
    position: absolute;
    top: 0;
    left: 10px;
    font-size: 16px;
    color: #fff;
    padding-top: 5px;
  }

  .ranking-list {
    margin-top: 10px;
    padding: 0 15px;

  }

  .ranking-list li {
    display: block;
    line-height: 28px;
    font-size: 14px;
    overflow: hidden;
    height: 28px;
    text-align: justify;
    color: #000;
  }

  .ranking-list li:hover {
    text-decoration: underline;
    color: #379ce9;
    cursor: pointer;
  }

  .ff0000 {
    color: #ff0000;
  }

  .ff5a00 {
    color: #ff5a00;
  }

  .ff7e00 {
    color: #ff7e00;
  }

  .recommend-bg {
    border: #ddd 1px solid;
    margin-bottom: 10px;
  }

  /*本站推荐*/

.recommend-title span {

    color: #379ce9;
  }

  .recommend-list {
    font-size: 14px;
    text-align: justify;
  }

  .recommend-list li a {
    display: block;
    line-height: 35px;
    position: relative;
    padding: 0 10px 0 20px;
    overflow: hidden;
    height: 35px;
    text-align: left;
    text-decoration: none;
    color: #2c3e50;
  }

  .recommend-list li a:before {
    content: '';
    width: 4px;
    height: 4px;
    border-radius: 4px;
    background: #379ce9;
    position: absolute;
    left: 10px;
    top: 15px;
  }

  .recommend-list li a:hover {
    text-decoration: underline;
    color: #379ce9;
  }

  /*本站推荐*/
  .recommend-title span {
    color: #379ce9;
  }

  .recommend-list {
    font-size: 14px;
    text-align: justify;
  }

  .recommend-list li a {
    display: block;
    line-height: 35px;
    position: relative;
    padding: 0 10px 0 20px;
    overflow: hidden;
    height: 35px;
    text-align: left;
    text-decoration: none;
    color: #2c3e50;
  }

  .recommend-list li a:before {
    content: '';
    width: 4px;
    height: 4px;
    border-radius: 4px;
    background: #379ce9;
    position: absolute;
    left: 10px;
    top: 15px;
  }

  .recommend-list li a:hover {
    text-decoration: underline;
    color: #379ce9;
  }

  /*本站推荐*/
  .recommend-title span {
    color: #379ce9;
  }

  .recommend-list {
    font-size: 14px;
    text-align: justify;
  }

  .recommend-list li a {
    display: block;
    line-height: 35px;
    position: relative;
    padding: 0 10px 0 20px;
    overflow: hidden;
    height: 35px;
    text-align: left;
    text-decoration: none;
    color: #2c3e50;
  }

  .recommend-list li a:before {
    content: '';
    width: 4px;
    height: 4px;
    border-radius: 4px;
    background: #379ce9;
    position: absolute;
    left: 10px;
    top: 15px;
  }

  .recommend-list li a:hover {
    text-decoration: underline;
    color: #379ce9;
  }

  .active-title, .recommend-title {
    font-size: 20px;
    color: #000;
    text-align: left;
    padding: 5px 0;
    margin: 10px 10px;
    border-bottom: #ddd 1px solid;
  }

  /*本站推荐*/
  .recommend-title span {
    color: #379ce9;
  }

  .recommend-list {
    font-size: 14px;
    text-align: justify;
  }

  .recommend-list li a {
    display: block;
    line-height: 35px;
    position: relative;
    padding: 0 10px 0 20px;
    overflow: hidden;
    height: 35px;
    text-align: left;
    text-decoration: none;
    color: #2c3e50;
  }

  .recommend-list li a:before {
    content: '';
    width: 4px;
    height: 4px;
    border-radius: 4px;
    background: #379ce9;
    position: absolute;
    left: 10px;
    top: 15px;
  }

  .recommend-list li a:hover {
    text-decoration: underline;
    color: #379ce9;
  }

  @media screen and (max-width: 1024px) {
    .main {
      width: 100%;
    }
    .tutorial-list-bg {width: 100%;}

  }

</style>



// WEBPACK FOOTER //
// src/components/tutorialList/tutorialSearch.vue